import { render, staticRenderFns } from "./PermissionGroupForm.vue?vue&type=template&id=b54b1df8&"
import script from "./PermissionGroupForm.vue?vue&type=script&lang=js&"
export * from "./PermissionGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports